import { v4 as uuidv4 } from "uuid";
import { generateStaticQuestionId } from "../../../../../utils/goalsUtils";

export const leadOthers = {
    "blockId": uuidv4(),
    "description": "<p>This section focuses on the following competencies: <strong>Communication, Lead by Example, Develop, and Relationships</strong>. Share how often you have experienced the leader demonstrating the below behaviors. Identify <strong>at least one behavior</strong> that the leader does not demonstrate often or always, as these highlight potential opportunities for growth.</p>",
    "selfDescription": "<p>This section focuses on the following competencies: <strong>Communication, Lead by Example, Develop, and Relationships</strong>. Share how often you demonstrate the below behaviors. Identify <strong>at least one behavior</strong> you don't demonstrate often or always, as these highlight potential opportunities for growth.</p>",
    "goalId": "dynamic360Strength",
    isRequired: true,
    feedbackBasedCondition: [
        {
            answeringCondition: [
                {
                    columnValues: ["1", "2"],
                    numberOfAnswersNeeded: 3,
                },
                {
                    columnValues: ["3", "4"],
                    numberOfAnswersNeeded: 3,
                },
                {
                    columnValues: ["5", "6"],
                    numberOfAnswersNeeded: 3,
                }
            ]
        }

    ],
    allowNAOption: true,
    "questions": [
        {
            "question": "",
            "options": [
                {
                    "label": "Never",
                    "value": "1"
                },
                {
                    "label": "Rarely",
                    "value": "2"
                },
                {
                    "label": "Occasionally",
                    "value": "3"
                },
                {
                    "label": "Sometimes",
                    "value": "4"
                },
                {
                    "label": "Often",
                    "value": "5"
                },
                {
                    "label": "Always",
                    "value": "6"
                },
                { "label": "Can't answer", "value": "0" }
            ],
            "questionDimension": "Custom Matrix",
            "type": "matrix",
            "qid": uuidv4(),
            "matrixQuestions": [
                {
                    "subCategoryId": generateStaticQuestionId("Communication"),
                    "subCategory": "Communication",
                    "staticQuestionId": generateStaticQuestionId("Communicates with transparency across the organization"),
                    "HTMLText": "<p>Communicates with transparency across the organization</p>",
                    "isSelected": true,
                    "text": "Communicates with transparency across the organization",
                    "value": uuidv4()
                },
                {
                    "subCategoryId": generateStaticQuestionId("Communication"),
                    "subCategory": "Communication",
                    "staticQuestionId": generateStaticQuestionId("Removes barriers and breaks down silos to improve communication"),
                    "HTMLText": "<p>Removes barriers and breaks down silos to improve communication</p>",
                    "isSelected": true,
                    "text": "Removes barriers and breaks down silos to improve communication",
                    "value": uuidv4()
                },
                {
                    "subCategoryId": generateStaticQuestionId("Communication"),
                    "subCategory": "Communication",
                    "staticQuestionId": generateStaticQuestionId("Communicates with clarity and impact"),
                    "HTMLText": "<p>Communicates with clarity and impact</p>",
                    "isSelected": true,
                    "text": "Communicates with clarity and impact",
                    "value": uuidv4()
                },

                {
                    "subCategoryId": generateStaticQuestionId("Lead by Example"),
                    "subCategory": "Lead by Example",
                    "staticQuestionId": generateStaticQuestionId("Sets high performance standards for self and others"),
                    "HTMLText": "<p>Sets high performance standards for self and others</p>",
                    "isSelected": true,
                    "text": "Sets high performance standards for self and others",
                    "value": uuidv4()
                },
                {
                    "subCategoryId": generateStaticQuestionId("Lead by Example"),
                    "subCategory": "Lead by Example",
                    "staticQuestionId": generateStaticQuestionId("Builds a culture based on trust and integrity"),
                    "HTMLText": "<p>Builds a culture based on trust and integrity</p>",
                    "isSelected": true,
                    "text": "Builds a culture based on trust and integrity",
                    "value": uuidv4()
                },
                {
                    "subCategoryId": generateStaticQuestionId("Lead by Example"),
                    "subCategory": "Lead by Example",
                    "staticQuestionId": generateStaticQuestionId("Demonstrates empathy and compassion"),
                    "HTMLText": "<p>Demonstrates empathy and compassion</p>",
                    "isSelected": true,
                    "text": "Demonstrates empathy and compassion",
                    "value": uuidv4()
                },


                {
                    "subCategoryId": generateStaticQuestionId("Develop"),
                    "subCategory": "Develop",
                    "staticQuestionId": generateStaticQuestionId("Supports a culture of continuous learning and development"),
                    "HTMLText": "<p>Supports a culture of continuous learning and development</p>",
                    "isSelected": true,
                    "text": "Supports a culture of continuous learning and development",
                    "value": uuidv4()
                },

                {
                    "subCategoryId": generateStaticQuestionId("Develop"),
                    "subCategory": "Develop",
                    "staticQuestionId": generateStaticQuestionId("Guides the growth and development of their team through individual development plans"),
                    "HTMLText": "<p>Guides the growth and development of their team through individual development plans</p>",
                    "isSelected": true,
                    "text": "Guides the growth and development of their team through individual development plans",
                    "value": uuidv4()
                },
                {
                    "subCategoryId": generateStaticQuestionId("Develop"),
                    "subCategory": "Develop",
                    "staticQuestionId": generateStaticQuestionId("Provides coaching that builds confidence and competency in others"),
                    "HTMLText": "<p>Provides coaching that builds confidence and competency in others</p>",
                    "isSelected": true,
                    "text": "Provides coaching that builds confidence and competency in others",
                    "value": uuidv4()
                },

                {
                    "subCategoryId": generateStaticQuestionId("Relationship"),
                    "subCategory": "Relationship",
                    "staticQuestionId": generateStaticQuestionId("Develops meaningful relationships with stakeholders across the organization"),
                    "HTMLText": "<p>Develops meaningful relationships with stakeholders across the organization</p>",
                    "isSelected": true,
                    "text": "Develops meaningful relationships with stakeholders across the organization",
                    "value": uuidv4()
                },

                {
                    "subCategoryId": generateStaticQuestionId("Relationship"),
                    "subCategory": "Relationship",
                    "staticQuestionId": generateStaticQuestionId("Interacts with others in a manner that reflects the Arc'teryx culture and values"),
                    "HTMLText": "<p>Interacts with others in a manner that reflects the Arc'teryx culture and values</p>",
                    "isSelected": true,
                    "text": "Interacts with others in a manner that reflects the Arc'teryx culture and values",
                    "value": uuidv4()
                },
                {
                    "subCategoryId": generateStaticQuestionId("Relationship"),
                    "subCategory": "Relationship",
                    "staticQuestionId": generateStaticQuestionId("Fosters a culture of collaboration and cooperation to overcome challenges"),
                    "HTMLText": "<p>Fosters a culture of collaboration and cooperation to overcome challenges</p>",
                    "isSelected": true,
                    "text": "Fosters a culture of collaboration and cooperation to overcome challenges",
                    "value": uuidv4()
                },


            ],
            "questionLabel": "Custom Matrix"
        }
    ],
    "isSelected": true,
    "type": "matrix",
    "dimension": "LEAD OTHERS"
}